import {parsePhoneNumber} from 'libphonenumber-js';
import {NumberFormat, PhoneNumber} from 'libphonenumber-js/types';

import {LocaleNameEnum} from '../provider/locale/locale-context-type';

export enum TimeSizeEnum {
    year = 'year',
    month = 'month',
    day = 'day',
    hour = 'hour',
    minute = 'minute',
    second = 'second',
}

export type NumberFormatOptionsType = Intl.NumberFormatOptions & {
    style?: 'decimal' | 'currency' | 'percent' | 'unit';
    unit?: TimeSizeEnum | 'liter' | 'percent';
    unitDisplay?: 'long' | 'short' | 'narrow';
    signDisplay?: 'auto' | 'never' | 'always' | 'exceptZero';
    notation?: 'compact' | 'scientific' | 'engineering';
    minimumFractionDigits?: number;
};

export function getFormattedNumber(
    localeName: LocaleNameEnum,
    value: number,
    options?: NumberFormatOptionsType
): string {
    try {
        return new Intl.NumberFormat(localeName, options).format(value);
    } catch {
        // not all browsers supports number format 'unit' (ex 'safari'). Trying to format with default style instead
        return new Intl.NumberFormat(localeName, {...options, style: 'decimal'}).format(value);
    }
}

type FormatMainType = 'numeric' | '2-digit';

export type DateTimeFormatOptionsType = {
    [TimeSizeEnum.year]?: FormatMainType;
    [TimeSizeEnum.month]?: FormatMainType | 'narrow' | 'short' | 'long';
    [TimeSizeEnum.day]?: FormatMainType;
    [TimeSizeEnum.hour]?: FormatMainType;
    [TimeSizeEnum.minute]?: FormatMainType;
    [TimeSizeEnum.second]?: FormatMainType;
    timeZone?: string;
};

export function getFormattedDateTime(
    localeName: LocaleNameEnum,
    date: Date | number,
    options?: DateTimeFormatOptionsType
): string {
    const formatter = new Intl.DateTimeFormat(localeName, options);

    return formatter.format(date);
}

export function getFormattedPhoneNumber(phone: string, format?: NumberFormat): string {
    try {
        const phoneNumber: PhoneNumber = parsePhoneNumber(phone);

        return phoneNumber.format(format || 'INTERNATIONAL');
    } catch (error: unknown) {
        console.error('[Error parsePhoneNumber]:', error);

        return phone;
    }
}
